export async function fetchDataFromServer(viewPath) {
    const apiDomain = getAPIDomain();
    const apiCall = `${apiDomain}/api/${viewPath}`;

    const response = await fetch(apiCall);
    return await response.json();
}

const getAPIDomain = () => isProduction
    ? djangoApiDomain
    : "http://127.0.0.1:8000";